import { AppPrimaryButton } from "../../ui/buttons";
import { useForgotPasswordContext } from "./ForgotPasswordProvider";
import { resetPassword } from "../../../../pages/api/user";
import { useModalContext } from "../../modals";
import { ResetPasswordSuccessModal } from "../../modals/material/successResetModal";

const INVALID_EMAIL_MESSAGE = "Invalid Email";

export const ForgotPasswordSubmitButton = () => {
  const { state, dispatch } = useForgotPasswordContext();
  const { showModal } = useModalContext();

  const handleSubmit = async () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(state.email)) {
      dispatch({
        emailError: "Email is invalid",
      });

      return;
    }

    try {
      dispatch({
        isLoading: true,
      });

      const reset = await resetPassword({ email: state.email });

      if (reset.statusCode && reset.statusCode != 200) {
        throw new Error(INVALID_EMAIL_MESSAGE);
      }

      showModal(<ResetPasswordSuccessModal />);
    } catch (e) {
      dispatch({
        emailError: INVALID_EMAIL_MESSAGE,
      });
    } finally {
      dispatch({
        isLoading: false,
      });
    }
  };

  return (
    <AppPrimaryButton
      disabled={state.isLoading}
      onClick={() => void handleSubmit()}
    >
      Continue
    </AppPrimaryButton>
  );
};
